import ApiService from './service';
import * as http from './http';
import { stringify } from 'query-string';

export class DataverseService extends ApiService {
    
    async getDetails(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        try {
            const response = await http.get(url, this.store);
            return response;
        } catch (err) {
            return { data: {} };
        }
    }

}